import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FixedBoxControlService {
  private fixedBoxShowed = new Subject<boolean>();

  // Observable boolean streams
  isFixedBoxShowed$ = this.fixedBoxShowed.asObservable();

  // Service message commands
  setFixedBox(isShowed: boolean) {
    this.fixedBoxShowed.next(isShowed);
  }
}
